module.exports = __webpack_public_path__ + "static/media/snapshift-5.4ab922f2.png";